import React, { useLayoutEffect, useRef, useState } from 'react';
import { Box, Typography } from '@mui/material';

const clamp = (lines) => ({
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: lines,
  overflow: 'hidden',
});

export default function SponsoredInlinePreview({ headline, subheadline }) {
  const title = useRef(null);
  const [titleLines, setTitleLines] = useState(2);
  useLayoutEffect(() => {
    const measure = () => {
      if (!title.current) return;
      const lineHeight = parseFloat(window.getComputedStyle(title.current).lineHeight);
      if (lineHeight > 0)
        setTitleLines(title.current.getBoundingClientRect().height > lineHeight + 1 ? 2 : 1);
    };
    measure();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure);
    if (title.current) observer?.observe(title.current);
    return () => observer?.disconnect();
  }, [headline]);
  return (
    <Box sx={{ minWidth: 0, flex: 1, py: 1.5, pr: 4 }}>
      <Typography ref={title} fontWeight={700} sx={{ lineHeight: '24px', ...clamp(2) }}>
        {headline || '광고 제목'}
      </Typography>
      {subheadline ? (
        <Typography variant="body2" color="text.secondary" sx={clamp(titleLines > 1 ? 1 : 2)}>
          {subheadline}
        </Typography>
      ) : null}
    </Box>
  );
}
